export enum TirsPolygoneEnum{
 AUTOMATIC = 'POLYGON.AUTOMATIC' ,
 DRILLED = 'POLYGON.DRILLED' ,
 MUCKPILE = 'POLYGON.MUCKPILE' ,
 DANGER_ZONE = 'POLYGON.DANGER_ZONE' ,
}